import { calculateLicensePrice, formatDecimal, LicenseType, SystemType } from "@ews/react-data";
import { useL10n } from "@ews/react-localization-context";
import { FC } from "react";

import { useActivePriceList } from "../ReactData/misc";

import style from './PriceList.module.scss';

export type PriceListTableProps = {
    licenseType: LicenseType,
    priceListId?: string;
    dataPoints?: number,
    textMessageRecipients?: number,
    systemType: SystemType;
};

const PriceListTable: FC<PriceListTableProps> = ({
    licenseType,
    priceListId,
    dataPoints = 0,
    textMessageRecipients = 0,
    systemType
}) => {
    const priceList = useActivePriceList(priceListId);

    const { translate: t, getLocale } = useL10n();
    const locale = getLocale();

    if (!priceList) return <></>;
    const priceStructure = calculateLicensePrice(
        priceList,
        licenseType,
        dataPoints,
        textMessageRecipients,
        systemType
    );

    if (!priceStructure.dataPoints) return <></>;

    return <table className={style.priceListTable}>
        <thead>
            <tr>
                <th></th>
                <th className={style.pricePerMonth}>{t('[REACT_PER_MONTH]')}</th>
                <th className={style.pricePerYear}>{t('[REACT_PER_YEAR]')}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>{t("[REACT_FROM_DATA_POINTS]", { dataPoints: `${dataPoints}` })}:</td>
                <td className={style.pricePerMonth}>{formatDecimal(locale!, priceStructure.dataPoints.price / 12)}</td>
                <td className={style.pricePerYear}>{formatDecimal(locale!, priceStructure.dataPoints.price)}</td>
            </tr>
            {priceStructure.textMessage && <tr>
                <td>{t("[REACT_TEXT_MESSAGE_RECIPIENTS]", { textMessageRecipients: `${textMessageRecipients}` })}:</td>
                <td className={style.pricePerMonth}>{formatDecimal(locale!, priceStructure.textMessage.price / 12)}</td>
                <td className={style.pricePerYear}>{formatDecimal(locale!, priceStructure.textMessage.price)}</td>
            </tr>
            }
        </tbody>

    </table>;

};

export default PriceListTable;